import { useI18n } from "@/i18n";

interface TermsContentProps {
  showHeader?: boolean;
}

export function TermsContent({ showHeader = false }: TermsContentProps) {
  const { t } = useI18n();

  return (
    <div className="terms-content">
      {showHeader && (
        <header className="terms-content-header">
          <h1>{t.terms.title}</h1>
          <p className="terms-subtitle">{t.terms.subtitle}</p>
          <p className="terms-updated">{t.terms.lastUpdated}: 2025-01-18</p>
        </header>
      )}

      {!showHeader && (
        <div className="terms-content-meta">
          <p className="terms-subtitle">{t.terms.subtitle}</p>
          <p className="terms-updated">{t.terms.lastUpdated}: 2025-01-18</p>
        </div>
      )}

      {/* Section 1 - 前言與同意條款 */}
      <section className="terms-section">
        <h2>{t.terms.section1Title}</h2>
        <p>{t.terms.section1Content}</p>
        <p className="warning-text">{t.terms.section1Warning}</p>
      </section>

      {/* Section 2 - 服務內容說明 */}
      <section className="terms-section">
        <h2>{t.terms.section2Title}</h2>
        <p>{t.terms.section2Content1}</p>

        <h3>{t.terms.section2_1Title}</h3>
        <p>{t.terms.section2_1Intro}</p>
        <ul>
          <li>{t.terms.section2_1Item1}</li>
          <li>{t.terms.section2_1Item2}</li>
          <li>{t.terms.section2_1Item3}</li>
          <li>{t.terms.section2_1Item4}</li>
        </ul>
        <p>{t.terms.section2_1NonCustody}</p>

        <h3>{t.terms.section2_3Title}</h3>
        <p>{t.terms.section2_3Content}</p>
      </section>

      {/* Section 3 - 使用者角色與責任 */}
      <section className="terms-section">
        <h2>{t.terms.section3Title}</h2>

        {/* 3.1 賣方責任 */}
        <h3>{t.terms.section3_1Title}</h3>
        <p>{t.terms.section3_1Intro}</p>
        <p>{t.terms.section3_1ContentDef}</p>
        <p>{t.terms.section3_1WarrantyIntro}</p>

        <h4>{t.terms.section3_1LegalTitle}</h4>
        <p>{t.terms.section3_1LegalContent}</p>

        <h4>{t.terms.section3_1ProhibitedTitle}</h4>
        <p>{t.terms.section3_1ProhibitedIntro}</p>
        <ul>
          <li>{t.terms.section3_1ProhibitedItem1}</li>
          <li>{t.terms.section3_1ProhibitedItem2}</li>
          <li>{t.terms.section3_1ProhibitedItem3}</li>
          <li>{t.terms.section3_1ProhibitedItem4}</li>
        </ul>

        <h4>{t.terms.section3_1ContentTitle}</h4>
        <p>{t.terms.section3_1ContentIntro}</p>
        <ul>
          <li>{t.terms.section3_1ContentItem1}</li>
          <li>{t.terms.section3_1ContentItem2}</li>
          <li>{t.terms.section3_1ContentItem3}</li>
          <li>{t.terms.section3_1ContentItem4}</li>
          <li>{t.terms.section3_1ContentItem5}</li>
          <li>{t.terms.section3_1ContentItem6}</li>
        </ul>

        <h4>{t.terms.section3_1MisleadingTitle}</h4>
        <p>{t.terms.section3_1MisleadingContent}</p>

        <h4>{t.terms.section3_1IPTitle}</h4>
        <p>{t.terms.section3_1IPContent}</p>

        <h4>{t.terms.section3_1DeliveryTitle}</h4>
        <p>{t.terms.section3_1DeliveryContent}</p>

        <h4>{t.terms.section3_1DisputeTitle}</h4>
        <p>{t.terms.section3_1DisputeContent}</p>

        <h4>{t.terms.section3_1EnforcementTitle}</h4>
        <p>{t.terms.section3_1EnforcementIntro}</p>
        <ul>
          <li>{t.terms.section3_1EnforcementItem1}</li>
          <li>{t.terms.section3_1EnforcementItem2}</li>
          <li>{t.terms.section3_1EnforcementItem3}</li>
          <li>{t.terms.section3_1EnforcementItem4}</li>
        </ul>

        <h4>{t.terms.section3_1IndemnityTitle}</h4>
        <p>{t.terms.section3_1IndemnityContent}</p>

        <h4>{t.terms.section3_1SurvivalTitle}</h4>
        <p>{t.terms.section3_1SurvivalContent}</p>

        {/* 3.2 買方責任 */}
        <h3>{t.terms.section3_2Title}</h3>
        <p>{t.terms.section3_2Intro}</p>

        <h4>{t.terms.section3_2JudgeTitle}</h4>
        <p>{t.terms.section3_2JudgeContent}</p>

        <h4>{t.terms.section3_2NoGuaranteeTitle}</h4>
        <p>{t.terms.section3_2NoGuaranteeContent}</p>

        <h4>{t.terms.section3_2BlockchainTitle}</h4>
        <p>{t.terms.section3_2BlockchainContent}</p>

        <h4>{t.terms.section3_2ControlTitle}</h4>
        <p>{t.terms.section3_2ControlContent}</p>

        <h4>{t.terms.section3_2IrreversibleTitle}</h4>
        <p>{t.terms.section3_2IrreversibleContent}</p>

        <h4>{t.terms.section3_2NoRefundTitle}</h4>
        <p>{t.terms.section3_2NoRefundContent}</p>

        <h4>{t.terms.section3_2AccessRiskTitle}</h4>
        <p>{t.terms.section3_2AccessRiskContent}</p>

        <h4>{t.terms.section3_2FeesTitle}</h4>
        <p>{t.terms.section3_2FeesContent}</p>

        <h4>{t.terms.section3_2DirectDisputeTitle}</h4>
        <p>{t.terms.section3_2DirectDisputeContent}</p>

        <h4>{t.terms.section3_2LegalUseTitle}</h4>
        <p>{t.terms.section3_2LegalUseContent}</p>
      </section>

      {/* Section 4 - 付款與交易性質 */}
      <section className="terms-section">
        <h2>{t.terms.section4Title}</h2>
        <p>{t.terms.section4Content1}</p>
        <p>{t.terms.section4Content2}</p>
        <ul>
          <li>{t.terms.section4Item1}</li>
          <li>{t.terms.section4Item2}</li>
          <li>{t.terms.section4Item3}</li>
          <li>{t.terms.section4Item4}</li>
          <li>{t.terms.section4Item5}</li>
          <li>{t.terms.section4Item6}</li>
        </ul>
      </section>

      {/* Section 5 - 平台角色與責任限制 */}
      <section className="terms-section">
        <h2>{t.terms.section5Title}</h2>
        <p>{t.terms.section5Content1}</p>
        <p>{t.terms.section5Content2}</p>
        <ul>
          <li>{t.terms.section5Item1}</li>
          <li>{t.terms.section5Item2}</li>
          <li>{t.terms.section5Item3}</li>
          <li>{t.terms.section5Item4}</li>
        </ul>
      </section>

      {/* Section 6 - 智慧財產權 */}
      <section className="terms-section">
        <h2>{t.terms.section6Title}</h2>
        <p>{t.terms.section6Content1}</p>
        <p>{t.terms.section6Content2}</p>
      </section>

      {/* Section 7 - 存取方式與使用者安全 */}
      <section className="terms-section">
        <h2>{t.terms.section7Title}</h2>
        <p>{t.terms.section7Content1}</p>
        <p>{t.terms.section7Content2}</p>
      </section>

      {/* Section 8 - 服務中斷與終止 */}
      <section className="terms-section">
        <h2>{t.terms.section8Title}</h2>
        <p>{t.terms.section8Content}</p>
      </section>

      {/* Section 9 - 免責聲明 */}
      <section className="terms-section">
        <h2>{t.terms.section9Title}</h2>
        <p>{t.terms.section9Content1}</p>
        <p>{t.terms.section9Content2}</p>
      </section>

      {/* Section 10 - 條款修訂 */}
      <section className="terms-section">
        <h2>{t.terms.section10Title}</h2>
        <p>{t.terms.section10Content}</p>
      </section>

      {/* Section 11 - 準據法與爭議處理 */}
      <section className="terms-section">
        <h2>{t.terms.section11Title}</h2>
        <p>{t.terms.section11Content1}</p>
        <p>{t.terms.section11Content2}</p>
      </section>

      {/* Section 12 - 風險揭露與反詐騙提醒 */}
      <section className="terms-section">
        <h2>{t.terms.section12Title}</h2>
        <p>{t.terms.section12Intro}</p>

        <h4>{t.terms.section12Risk1Title}</h4>
        <p>{t.terms.section12Risk1Content}</p>

        <h4>{t.terms.section12Risk2Title}</h4>
        <p>{t.terms.section12Risk2Content}</p>

        <h4>{t.terms.section12Risk3Title}</h4>
        <p>{t.terms.section12Risk3Content}</p>

        <h4>{t.terms.section12Risk4Title}</h4>
        <p>{t.terms.section12Risk4Content}</p>

        <p className="warning-text">{t.terms.section12ScamWarning}</p>
        <ul>
          <li>{t.terms.section12ScamItem1}</li>
          <li>{t.terms.section12ScamItem2}</li>
          <li>{t.terms.section12ScamItem3}</li>
        </ul>
        <p>{t.terms.section12Disclaimer}</p>
      </section>

      {/* Section 13 - 通報、處置與鏈上資訊提供 */}
      <section className="terms-section">
        <h2>{t.terms.section13Title}</h2>

        <h4>{t.terms.section13ReportTitle}</h4>
        <p>{t.terms.section13ReportContent}</p>

        <h4>{t.terms.section13EnforcementTitle}</h4>
        <p>{t.terms.section13EnforcementIntro}</p>
        <ul>
          <li>{t.terms.section13EnforcementItem1}</li>
          <li>{t.terms.section13EnforcementItem2}</li>
          <li>{t.terms.section13EnforcementItem3}</li>
        </ul>

        <h4>{t.terms.section13InfoTitle}</h4>
        <p>{t.terms.section13InfoContent}</p>

        <h4>{t.terms.section13NoRecoveryTitle}</h4>
        <p>{t.terms.section13NoRecoveryContent}</p>
      </section>

      {/* Section 14 - 合規配合與資料留存 */}
      <section className="terms-section">
        <h2>{t.terms.section14Title}</h2>
        <p>{t.terms.section14Content1}</p>
        <p>{t.terms.section14Content2}</p>
      </section>

      {/* Section 15 - 責任限制 */}
      <section className="terms-section">
        <h2>{t.terms.section15Title}</h2>
        <p>{t.terms.section15Intro}</p>
        <ul>
          <li>{t.terms.section15Item1}</li>
          <li>{t.terms.section15Item2}</li>
          <li>{t.terms.section15Item3}</li>
        </ul>
      </section>

      {/* Appendix 1 - 禁止用途政策 (AUP) */}
      <section className="terms-section terms-appendix">
        <h2>{t.terms.appendix1Title}</h2>
        <p className="appendix-note">{t.terms.appendix1Intro}</p>
        <p>{t.terms.appendix1Purpose}</p>

        <h3>{t.terms.appendix1ContentTitle}</h3>
        <p>{t.terms.appendix1ContentIntro}</p>
        <ul>
          <li>{t.terms.appendix1ContentItem1}</li>
          <li>{t.terms.appendix1ContentItem2}</li>
          <li>{t.terms.appendix1ContentItem3}</li>
          <li>{t.terms.appendix1ContentItem4}</li>
          <li>{t.terms.appendix1ContentItem5}</li>
          <li>{t.terms.appendix1ContentItem6}</li>
        </ul>

        <h3>{t.terms.appendix1BehaviorTitle}</h3>
        <p>{t.terms.appendix1BehaviorIntro}</p>
        <ul>
          <li>{t.terms.appendix1BehaviorItem1}</li>
          <li>{t.terms.appendix1BehaviorItem2}</li>
          <li>{t.terms.appendix1BehaviorItem3}</li>
          <li>{t.terms.appendix1BehaviorItem4}</li>
          <li>{t.terms.appendix1BehaviorItem5}</li>
          <li>{t.terms.appendix1BehaviorItem6}</li>
        </ul>

        <h3>{t.terms.appendix1EnforcementTitle}</h3>
        <p>{t.terms.appendix1EnforcementContent}</p>
      </section>

      {/* Appendix 2 - 侵權通知與下架機制 */}
      <section className="terms-section terms-appendix">
        <h2>{t.terms.appendix2Title}</h2>
        <p className="appendix-note">{t.terms.appendix2Intro}</p>
        <p>{t.terms.appendix2Purpose}</p>

        <h3>{t.terms.appendix2NoticeTitle}</h3>
        <p>{t.terms.appendix2NoticeIntro}</p>
        <ul>
          <li>{t.terms.appendix2NoticeItem1}</li>
          <li>{t.terms.appendix2NoticeItem2}</li>
          <li>{t.terms.appendix2NoticeItem3}</li>
          <li>{t.terms.appendix2NoticeItem4}</li>
          <li>{t.terms.appendix2NoticeItem5}</li>
        </ul>

        <h3>{t.terms.appendix2ProcessTitle}</h3>
        <p>{t.terms.appendix2ProcessContent}</p>

        <h3>{t.terms.appendix2CounterTitle}</h3>
        <p>{t.terms.appendix2CounterContent}</p>

        <h3>{t.terms.appendix2RepeatTitle}</h3>
        <p>{t.terms.appendix2RepeatContent}</p>

        <h3>{t.terms.appendix2LiabilityTitle}</h3>
        <p>{t.terms.appendix2LiabilityContent}</p>
      </section>
    </div>
  );
}
